import Schema from 'AppReact/schema';
import { today } from 'AppReact';

export default {
  selectedDate: Schema('jsDate', 'primitive-nullable', { defaultValue: null }),
  selectedYear: Schema('integer', 'primitive', { defaultValue: today().getFullYear() }),
  selectedTimeOption: Schema('string', 'primitive-nullable', { defaultValue: null }),
  yearListRef: Schema({}, 'object', { defaultValue: null }),
  monthListRef: Schema({}, 'object', { defaultValue: null }),
}